export const hostUpdateGiveawayText = {
  errorDescription: 'Failed to update giveaway stock',
};
